module.exports = __webpack_public_path__ + "img/shidu.6557ecd8.png";